import {
    Card,
    CardContent,
    Container,
    Grid,
    LinearProgress,
    Stack,
    Typography,
    Chip,
    Divider,
    Box,
    Button
} from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useDataProvider } from "react-admin";
import WarehouseTwoToneIcon from '@mui/icons-material/WarehouseTwoTone';
import HouseTwoToneIcon from '@mui/icons-material/HouseTwoTone';
import DomainTwoToneIcon from '@mui/icons-material/DomainTwoTone';
import SchoolIcon from '@mui/icons-material/School';
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';
import { ReleaseDates } from "../admin/ReleaseDates";
import packageJson from '../../../package.json'
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import PrintIcon from '@mui/icons-material/Print';

// Local printer storage service (same as in Settings and CustomLabels)
const LocalPrinterStorage = {
    STORAGE_KEY_SELECTIONS: 'zWarehouse_printer_selections',
    
    getPrinterSelections() {
        try {
            const stored = localStorage.getItem(this.STORAGE_KEY_SELECTIONS);
            return stored ? JSON.parse(stored) : {};
        } catch (error) {
            console.error('Error loading printer selections:', error);
            return {};
        }
    }
};

export const Dashboard = () => {
    const dataProvider = useDataProvider()
    const [teacherStats, setTeacherStats] = useState({})
    const [studentHomeStats, setStudentHomeStats] = useState({})
    const [studentSchoolStats, setStudentSchoolStats] = useState({})
    const [bulkStats, setBulkStats] = useState({})
    // const [printers, setPrinters] = useState([])
    const [settings, setSettings] = useState({})
    const [releaseDates, setReleaseDates] = useState([])
    const [printApiStatus, setPrintApiStatus] = useState('')
    const [selectedPrinters, setSelectedPrinters] = useState({})
    const [availablePrinters, setAvailablePrinters] = useState([])

    useEffect(() => {
        // TEACHER
        dataProvider.getStats('TeacherOrder', { status: 'New'})
            .then(resp => {
                const { data: { count }} = resp
                setTeacherStats(teacherStats => ({...teacherStats, new: +count}))
            })

        dataProvider.getStats('TeacherOrder', { status: 'On Deck'})
            .then(resp => {
                const { data: { count }} = resp
                setTeacherStats(teacherStats => ({...teacherStats, ondeck: +count}))
            })

        dataProvider.getStats('TeacherOrder', { status: 'Shipped'})
            .then(resp => {
                const { data: { count }} = resp
                setTeacherStats(teacherStats => ({...teacherStats, shipped: +count}))
            })

        // STUDENT HOME
        dataProvider.getStats('StudentOrderKit', { delivery: 'home', status: 'New' })
            .then(resp => {
                const { data: { count }} = resp
                setStudentHomeStats(studentHomeStats => ({ ...studentHomeStats, new: +count }))
            })

        dataProvider.getStats('StudentOrderKit', { delivery: 'home', status: 'On Deck' })
            .then(resp => {
                const { data: { count }} = resp
                setStudentHomeStats(studentHomeStats => ({ ...studentHomeStats, ondeck: +count }))
            })

        dataProvider.getStats('StudentOrderKit', { delivery: 'home', status: 'Shipped' })
            .then(resp => {
                const { data: { count }} = resp
                setStudentHomeStats(studentHomeStats => ({ ...studentHomeStats, shipped: +count }))
            })

        // STUDENT SCHOOL
        dataProvider.getStats('StudentOrderKit', { delivery: 'school', status: 'New' })
            .then(resp => {
                const { data: { count }} = resp
                setStudentSchoolStats(studentSchoolStats => ({...studentSchoolStats, new: +count }))
            })

        dataProvider.getStats('StudentOrderKit', { delivery: 'school', status: 'On Deck' })
            .then(resp => {
                const { data: { count }} = resp
                setStudentSchoolStats(studentSchoolStats => ({ ...studentSchoolStats, ondeck: +count }))
            })

        dataProvider.getStats('StudentOrderKit', { delivery: 'school', status: 'Shipped' })
            .then(resp => {
                const { data: { count }} = resp
                setStudentSchoolStats(studentSchoolStats => ({ ...studentSchoolStats, shipped: +count }))
            })

        // BULK
        dataProvider.getStats('BulkOrder', { status: 'New'})
            .then(resp => {
                const { data: { count }} = resp
                setBulkStats(bulkStats => ({ ...bulkStats, new: +count }))
            })

        dataProvider.getStats('BulkOrder', { status: 'On Deck'})
            .then(resp => {
                const { data: { count }} = resp
                setBulkStats(bulkStats => ({ ...bulkStats, ondeck: +count }))
            })

        dataProvider.getStats('BulkOrder', { status: 'Shipped'})
            .then(resp => {
                const { data: { count }} = resp
                setBulkStats(bulkStats => ({ ...bulkStats, shipped: +count }))
            })

        dataProvider.getConstants()
            .then(({ data }) => {
                const dates = data.filter(constant => {
                    const item = Object.keys(constant)[0]
                    return item.startsWith('release_date')
                })

                setReleaseDates(dates)
            })

        dataProvider.getPrintApiStatus()
            .then(resp => {
                const { data: { status }} = resp
                setPrintApiStatus(status)
                
                // If API is connected, fetch printer information
                if (status === 'connected' || status === 'online') {
                    return dataProvider.getPrintApiPrinters()
                }
            })
            .then(resp => {
                if (resp && resp.data) {
                    setAvailablePrinters(resp.data)
                }
            })
            .catch(error => {
                console.error('Error checking printer API status:', error)
                setPrintApiStatus('disconnected')
            })

    }, [dataProvider])

    // useEffect(() => {
    //     const { BrowserPrint, Zebra } = window

    //     BrowserPrint.getLocalDevices(devices => {
    //         console.log("Devices", devices)
    //         const printers = []

    //         if (devices && devices.printer) {
    //             console.log("Printers", devices.printer)

    //             devices.printer.forEach(device => {
    //                 const zp = new Zebra.Printer(device)
    //                 zp.isPrinterReady()


    //                 // zp.getStatus()
    //                 //     .then(status => {
    //                 //         printers.push({
    //                 //             name: device.name,
    //                 //             status: status.getMessage()
    //                 //         })
    //                 //     })
    //                 //     .catch(e => {
    //                 //         console.error("Printer Error", e)
    //                 //     })
    //             })
    //             setPrinters(printers)
    //         }
    //     })
    // }, [])

    useEffect(() => {
        let settings = JSON.parse(localStorage.getItem('zWarehouse'))

        if (!settings) {
            settings = { environment: 'production' }
            localStorage.setItem('zWarehouse', JSON.stringify(settings))
        }

        setSettings(settings)
        
        // Load printer selections from local storage
        const printerSelections = LocalPrinterStorage.getPrinterSelections();
        setSelectedPrinters(printerSelections);
        console.log('Loaded printer selections from local storage:', printerSelections);
    }, [])

    const getStatusIcon = (status) => {
        switch (status) {
            case 'connected':
            case 'online':
                return <CheckIcon color="success" fontSize="small" />
            case 'disconnected':
            case 'offline':
                return <ErrorIcon color="error" fontSize="small" />
            default:
                return <WarningIcon color="warning" fontSize="small" />
        }
    }

    const getStatusColor = (status) => {
        switch (status) {
            case 'connected':
            case 'online':
                return 'success'
            case 'disconnected':
            case 'offline':
                return 'error'
            default:
                return 'warning'
        }
    }

    const getSelectedPrinterInfo = (printerType) => {
        const printer = selectedPrinters[printerType]
        if (!printer) {
            // console.log(`No printer selected for type: ${printerType}`);
            return null;
        }
        
        // console.log(`Getting printer info for ${printerType}:`, printer);
        
        // Find the printer in available printers to get current status
        const availablePrinter = availablePrinters.find(ap => ap.ip === printer.ip)
        const currentStatus = availablePrinter ? availablePrinter.status : 'unknown';
        
        const printerInfo = {
            ...printer,
            currentStatus: currentStatus
        };
        
        // console.log(`Printer info for ${printerType}:`, printerInfo);
        return printerInfo;
    }

    const refreshPrinterSelections = () => {
        const printerSelections = LocalPrinterStorage.getPrinterSelections();
        setSelectedPrinters(printerSelections);
        console.log('Refreshed printer selections:', printerSelections);
    }

    return (
        <Container>
            <Stack direction='row' spacing={2} sx={{ m: 4}}>
                <WarehouseTwoToneIcon sx={{ fontSize: 48 }} color='primary' />
                <Typography variant='h3' color='primary'>
                    School Start Warehouse
                </Typography>
            </Stack>

            <Grid container spacing={4}>
                <Grid item sm={4}>
                    <Stack spacing={2}>
                        <Card>
                            {!studentHomeStats.ondeck && <LinearProgress />}
                            <CardContent>
                                <Link to='/StudentOrderHome'>
                                    <Stack direction='row' justifyContent='space-between'>
                                        <Typography variant='h5'>Student Orders</Typography>
                                            <HouseTwoToneIcon />
                                    </Stack>
                                </Link>


                                <Typography variant='h6' fontWeight={500}>
                                    Home Delivery
                                </Typography>

                                <Typography color='secondary'>Unprocessed: {studentHomeStats.new}</Typography>
                                <Typography color='secondary'>On Deck: {studentHomeStats.ondeck}</Typography>
                                <Typography color='secondary'>Shipped: {studentHomeStats.shipped}</Typography>
                            </CardContent>
                        </Card>

                        <Card>
                            {!studentSchoolStats.ondeck && <LinearProgress />}
                            <CardContent>
                                <Link to='/StudentOrderSchool'>
                                    <Stack direction='row' justifyContent='space-between'>
                                        <Typography variant='h5'>Student Orders</Typography>
                                            <DomainTwoToneIcon />
                                    </Stack>
                                </Link>

                                <Typography variant='h6' fontWeight={500}>
                                    School Delivery
                                </Typography>

                                <Typography color='secondary'>Unprocessed: {studentSchoolStats.new}</Typography>
                                <Typography color='secondary'>On Deck: {studentSchoolStats.ondeck}</Typography>
                                <Typography color='secondary'>Shipped: {studentSchoolStats.shipped}</Typography>

                            </CardContent>
                        </Card>

                        <Card>
                            {!teacherStats.ondeck && <LinearProgress />}
                            <CardContent>
                                <Link to='/TeacherOrder'>
                                    <Stack direction='row' justifyContent='space-between'>
                                        <Typography variant='h5'>Teacher Orders</Typography>
                                        <SchoolIcon />
                                    </Stack>
                                </Link>

                                <Typography color='secondary'>Unprocessed: {teacherStats.new}</Typography>
                                <Typography color='secondary'>On Deck: {teacherStats.ondeck}</Typography>
                                <Typography color='secondary'>Shipped: {teacherStats.shipped}</Typography>

                            </CardContent>
                        </Card>

                        <Card>
                            {!bulkStats.ondeck && <LinearProgress />}
                            <CardContent>
                                <Link to='/BulkOrder'>
                                    <Stack direction='row' justifyContent='space-between'>
                                        <Typography variant='h5'>Bulk Orders</Typography>
                                        <LocalShippingTwoToneIcon />
                                    </Stack>
                                </Link>

                                <Typography color='secondary'>Unprocessed: {bulkStats.new}</Typography>
                                <Typography color='secondary'>On Deck: {bulkStats.ondeck}</Typography>
                                <Typography color='secondary'>Shipped {bulkStats.shipped}</Typography>
                            </CardContent>
                        </Card>

                    </Stack>
                </Grid>

                <Grid item sm={6}>
                    <Stack spacing={2}>
                        {releaseDates && <ReleaseDates dates={releaseDates} />}
                        
                        <Card>
                            <CardContent>
                                <Stack spacing={1}>
                                    <Typography>Environment: {settings.environment}</Typography>
                                    <Typography>Legacy Printer(s):</Typography>
                                    {settings.printers && Object.keys(settings.printers).map((type, idx) => (
                                        <Typography key={idx}>
                                            {type}: {settings.printers[type].name} [{settings.printers[type].uid}]
                                        </Typography>
                                    ))}

                                    {/* {printers &&
                                        printers.map((printer, idx) => (
                                        <Stack key={idx}
                                            direction='row'
                                            spacing={2}
                                            justifyContent='space-between'>
                                            <Typography>{printer.name}</Typography>
                                            <Typography color={printer.status === 'Ready' ? 'primary' : 'error'}>
                                                {printer.status}
                                            </Typography>
                                        </Stack>
                                    ))} */}

                                    <Typography color='gray'>Version: {packageJson.version}</Typography>

                                </Stack>

                            </CardContent>
                        </Card>

                        <Card>
                            <CardContent>
                                <Stack spacing={2}>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <PrintIcon color="primary" />
                                        <Typography variant="h6">Printer API Status</Typography>
                                        <Chip
                                            label={printApiStatus || 'Unknown'}
                                            color={getStatusColor(printApiStatus)}
                                            icon={getStatusIcon(printApiStatus)}
                                            size="small"
                                        />
                                    </Stack>

                                    <Divider />

                                    <Box>
                                        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
                                            <Typography variant="subtitle2" color="text.secondary">
                                                Selected Printers
                                            </Typography>
                                            <Button
                                                size="small"
                                                variant="outlined"
                                                onClick={refreshPrinterSelections}
                                            >
                                                Refresh
                                            </Button>
                                        </Stack>
                                        
                                        {Object.keys(selectedPrinters).length === 0 ? (
                                            <Typography variant="body2" color="text.secondary">
                                                No printers selected. Go to Settings to configure printers.
                                            </Typography>
                                        ) : (
                                            <Stack spacing={1}>
                                                {getSelectedPrinterInfo('box') && (
                                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                            <Typography variant="body2" fontWeight={500}>Box Labels:</Typography>
                                                            <Stack>
                                                                <Typography variant="body2">
                                                                    {getSelectedPrinterInfo('box').name || getSelectedPrinterInfo('box').ip}
                                                                </Typography>
                                                                {getSelectedPrinterInfo('box').location && (
                                                                    <Typography variant="caption" color="text.secondary">
                                                                        {getSelectedPrinterInfo('box').location}
                                                                    </Typography>
                                                                )}
                                                            </Stack>
                                                        </Stack>
                                                        <Chip
                                                            label={getSelectedPrinterInfo('box').currentStatus}
                                                            color={getStatusColor(getSelectedPrinterInfo('box').currentStatus)}
                                                            size="small"
                                                            variant="outlined"
                                                        />
                                                    </Stack>
                                                )}

                                                {getSelectedPrinterInfo('bag') && (
                                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                            <Typography variant="body2" fontWeight={500}>Bag Labels:</Typography>
                                                            <Stack>
                                                                <Typography variant="body2">
                                                                    {getSelectedPrinterInfo('bag').name || getSelectedPrinterInfo('bag').ip}
                                                                </Typography>
                                                                {getSelectedPrinterInfo('bag').location && (
                                                                    <Typography variant="caption" color="text.secondary">
                                                                        {getSelectedPrinterInfo('bag').location}
                                                                    </Typography>
                                                                )}
                                                            </Stack>
                                                        </Stack>
                                                        <Chip
                                                            label={getSelectedPrinterInfo('bag').currentStatus}
                                                            color={getStatusColor(getSelectedPrinterInfo('bag').currentStatus)}
                                                            size="small"
                                                            variant="outlined"
                                                        />
                                                    </Stack>
                                                )}

                                                {getSelectedPrinterInfo('student') && (
                                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                            <Typography variant="body2" fontWeight={500}>Student Labels:</Typography>
                                                            <Stack>
                                                                <Typography variant="body2">
                                                                    {getSelectedPrinterInfo('student').name || getSelectedPrinterInfo('student').ip}
                                                                </Typography>
                                                                {getSelectedPrinterInfo('student').location && (
                                                                    <Typography variant="caption" color="text.secondary">
                                                                        {getSelectedPrinterInfo('student').location}
                                                                    </Typography>
                                                                )}
                                                            </Stack>
                                                        </Stack>
                                                        <Chip
                                                            label={getSelectedPrinterInfo('student').currentStatus}
                                                            color={getStatusColor(getSelectedPrinterInfo('student').currentStatus)}
                                                            size="small"
                                                            variant="outlined"
                                                        />
                                                    </Stack>
                                                )}
                                            </Stack>
                                        )}
                                    </Box>

                                    {availablePrinters.length > 0 && (
                                        <>
                                            <Divider />
                                            <Box>
                                                <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                                    Available Printers ({availablePrinters.length})
                                                </Typography>
                                                <Stack spacing={0.5}>
                                                    {availablePrinters.slice(0, 3).map((printer, index) => (
                                                        <Stack key={index} direction="row" justifyContent="space-between" alignItems="center">
                                                            <Typography variant="body2" noWrap sx={{ maxWidth: '60%' }}>
                                                                {printer.name || printer.ip}
                                                            </Typography>
                                                            <Chip
                                                                label={printer.status || 'unknown'}
                                                                color={getStatusColor(printer.status)}
                                                                size="small"
                                                                variant="outlined"
                                                            />
                                                        </Stack>
                                                    ))}
                                                    {availablePrinters.length > 3 && (
                                                        <Typography variant="body2" color="text.secondary">
                                                            +{availablePrinters.length - 3} more printers
                                                        </Typography>
                                                    )}
                                                </Stack>
                                            </Box>
                                        </>
                                    )}
                                </Stack>
                            </CardContent>
                        </Card>
                    </Stack>

                </Grid>
            </Grid>
        </Container>
    )
}